import { ROUTES } from '@/lib/constants/routes';
import { STORAGE_KEYS } from '@/constants/storage';
import NavigationService from '@/services/navigationService';

/**
 * Redirects to the unauthorize page, remembering the current path so
 * the unauthorize page can send the user back once /token is healthy again.
 */
export function redirectToUnauthorize(currentPath: string = window.location.pathname) {
  if (currentPath === ROUTES.AUTH.UNAUTHORIZED) return;

  try {
    sessionStorage.setItem(STORAGE_KEYS.UNAUTHORIZE_RETURN_PATH, currentPath);
  } catch {
    // ignore storage errors
  }

  NavigationService.navigateTo(ROUTES.AUTH.UNAUTHORIZED);
}

/** Reads and clears the path saved before redirecting to unauthorize. Defaults to home. */
export function consumeUnauthorizeReturnPath(): string {
  try {
    const path = sessionStorage.getItem(STORAGE_KEYS.UNAUTHORIZE_RETURN_PATH);
    sessionStorage.removeItem(STORAGE_KEYS.UNAUTHORIZE_RETURN_PATH);
    return path || ROUTES.HOME;
  } catch {
    return ROUTES.HOME;
  }
}
